// import ajax from './ajax';
/**
 * 节流函数
 * @param fn
 * @param gapTime
 * @returns {Function}
 */
import Vue from 'vue'
export default new Vue
// 节流函数
export function throttle(method, delay, duration) {
	var that = this;
	var timer = this.timer;
	var begin = new Date().getTime();
	return function() {
		var current = new Date().getTime();
		clearTimeout(timer);
		if (current - begin >= duration) {
			method();
			begin = current;
		} else {
			that.timer = setTimeout(function() {
				method();
			}, delay);
		}
	};
}
// 格式化时间戳
export function fmtTime(obj) {
    if (obj !== "") {
        var date = new Date(obj);
        var y = date.getHours() + ":";
        var m = date.getMinutes() + ":";
        var d = date.getSeconds() + "";
        return y + m + d;
    } else {
        return "";
    }
}
/**
 * 设置缓存
 * @returns {*}
 */
export const setStorage =  function(key, data){
    var v = data;
    if (typeof v == 'object') {
        v = JSON.stringify(v);
        v = 'obj-' + v;
    } else {
        v = 'str-' + v;
    }
    window.sessionStorage.setItem(key, v);
    // sessionStorage.setItem(key, data)
} 
/**
 * 获取缓存
 * @returns {*}
 */
export const getStorage = function(key){
    
    var v = window.sessionStorage.getItem(key);
    if(!v) return;
    if (v.indexOf('obj-') === 0) {
        v = v.slice(4);
        return JSON.parse(v);
    } else if (v.indexOf('str-') === 0) {
        return v.slice(4);
    }
}
// 判断是否是空对象
export function isEmptyObject(obj) {
    for (var key in obj) {
        return false
    };
    return true
}
// 验证手机号
export const testMobile = function (mobile) {
    return /^1[0-9]{10}$/.test(mobile)
  }



// WEBPACK FOOTER //
// ./src/utils/utils.js